import _slicedToArray from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _classCallCheck from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _inherits from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _createSuper from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createSuper";
// @generated by protobuf-ts 2.8.0 with parameter add_pb_suffix,long_type_string,output_javascript_es2015
// @generated from protobuf file "proto/edox/access/access.proto" (package "proto.edox.access", syntax proto3)
// tslint:disable
import { WireType } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MESSAGE_TYPE } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Date } from "@finam/tx-proto-grpc-proto/google/type/date_pb";
import { BusinessFormType } from "@finam/tx-proto-grpc-proto-common/proto/common/business_form_type_pb";
import { Timestamp } from "@finam/tx-proto-lib-google-wellknown/google/protobuf/timestamp_pb";
/**
 * @generated from protobuf enum proto.edox.access.PersonalData.Gender
 */

export var PersonalData_Gender;

(function (PersonalData_Gender) {
  /**
   * @generated from protobuf enum value: UNKNOWN = 0;
   */
  PersonalData_Gender[PersonalData_Gender["UNKNOWN"] = 0] = "UNKNOWN";
  /**
   * @generated from protobuf enum value: MALE = 1;
   */

  PersonalData_Gender[PersonalData_Gender["MALE"] = 1] = "MALE";
  /**
   * @generated from protobuf enum value: FEMALE = 2;
   */

  PersonalData_Gender[PersonalData_Gender["FEMALE"] = 2] = "FEMALE";
})(PersonalData_Gender || (PersonalData_Gender = {}));
/**
 * Статус верификации УЗ
 *
 * @generated from protobuf enum proto.edox.access.AccountVerificationStatus
 */


export var AccountVerificationStatus;

(function (AccountVerificationStatus) {
  /**
   * @generated from protobuf enum value: ACCOUNT_VERIFICATION_STATUS_UNKNOWN = 0;
   */
  AccountVerificationStatus[AccountVerificationStatus["ACCOUNT_VERIFICATION_STATUS_UNKNOWN"] = 0] = "ACCOUNT_VERIFICATION_STATUS_UNKNOWN";
  /**
   * @generated from protobuf enum value: NOT_VERIFIED = 1;
   */

  AccountVerificationStatus[AccountVerificationStatus["NOT_VERIFIED"] = 1] = "NOT_VERIFIED";
  /**
   * @generated from protobuf enum value: VERIFIED = 2;
   */

  AccountVerificationStatus[AccountVerificationStatus["VERIFIED"] = 2] = "VERIFIED";
})(AccountVerificationStatus || (AccountVerificationStatus = {}));
/**
 * тип пользователя
 *
 * @generated from protobuf enum proto.edox.access.UserType
 */


export var UserType;

(function (UserType) {
  /**
   * @generated from protobuf enum value: USER_TYPE_UNKNOWN = 0;
   */
  UserType[UserType["USER_TYPE_UNKNOWN"] = 0] = "USER_TYPE_UNKNOWN";
  /**
   * Сотрудник
   *
   * @generated from protobuf enum value: EMPLOYEE = 1;
   */

  UserType[UserType["EMPLOYEE"] = 1] = "EMPLOYEE";
  /**
   * Клиент
   *
   * @generated from protobuf enum value: COMMON = 2;
   */

  UserType[UserType["COMMON"] = 2] = "COMMON";
  /**
   * Администратор
   *
   * @generated from protobuf enum value: ADMINISTRATOR = 3;
   */

  UserType[UserType["ADMINISTRATOR"] = 3] = "ADMINISTRATOR";
  /**
   * Представитель
   *
   * @generated from protobuf enum value: REPRESENTATIVE = 4;
   */

  UserType[UserType["REPRESENTATIVE"] = 4] = "REPRESENTATIVE";
})(UserType || (UserType = {}));
/**
 * @generated from protobuf enum proto.edox.access.PassportType
 */


export var PassportType;

(function (PassportType) {
  /**
   * @generated from protobuf enum value: PASSPORT_TYPE_UNKNOWN = 0;
   */
  PassportType[PassportType["PASSPORT_TYPE_UNKNOWN"] = 0] = "PASSPORT_TYPE_UNKNOWN";
  /**
   * Паспорт РФ
   *
   * @generated from protobuf enum value: RUSSIAN_PASSPORT = 1;
   */

  PassportType[PassportType["RUSSIAN_PASSPORT"] = 1] = "RUSSIAN_PASSPORT";
  /**
   * Паспорт иностранного гражданина
   *
   * @generated from protobuf enum value: FOREIGN_CITIZEN_PASSPORT = 2;
   */

  PassportType[PassportType["FOREIGN_CITIZEN_PASSPORT"] = 2] = "FOREIGN_CITIZEN_PASSPORT";
})(PassportType || (PassportType = {})); // @generated message type with reflection information, may provide speed optimized methods


var PassportId$Type = /*#__PURE__*/function (_MessageType) {
  _inherits(PassportId$Type, _MessageType);

  var _super = _createSuper(PassportId$Type);

  function PassportId$Type() {
    _classCallCheck(this, PassportId$Type);

    return _super.call(this, "proto.edox.access.PassportId", [{
      no: 1,
      name: "series",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 2,
      name: "number",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }]);
  }

  _createClass(PassportId$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        series: "",
        number: ""
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag = reader.tag(),
            _reader$tag2 = _slicedToArray(_reader$tag, 2),
            fieldNo = _reader$tag2[0],
            wireType = _reader$tag2[1];

        switch (fieldNo) {
          case
          /* string series */
          1:
            message.series = reader.string();
            break;

          case
          /* string number */
          2:
            message.number = reader.string();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* string series = 1; */
      if (message.series !== "") writer.tag(1, WireType.LengthDelimited).string(message.series);
      /* string number = 2; */

      if (message.number !== "") writer.tag(2, WireType.LengthDelimited).string(message.number);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return PassportId$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message proto.edox.access.PassportId
 */


export var PassportId = new PassportId$Type(); // @generated message type with reflection information, may provide speed optimized methods

var UserAccount$Type = /*#__PURE__*/function (_MessageType2) {
  _inherits(UserAccount$Type, _MessageType2);

  var _super2 = _createSuper(UserAccount$Type);

  function UserAccount$Type() {
    _classCallCheck(this, UserAccount$Type);

    return _super2.call(this, "proto.edox.access.UserAccount", [{
      no: 1,
      name: "authentication_id",
      kind: "scalar",
      T: 4
      /*ScalarType.UINT64*/

    }, {
      no: 2,
      name: "login",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 3,
      name: "account_verification_status",
      kind: "enum",
      T: function T() {
        return ["proto.edox.access.AccountVerificationStatus", AccountVerificationStatus];
      }
    }, {
      no: 4,
      name: "full_name",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 5,
      name: "short_name",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 6,
      name: "created_at",
      kind: "message",
      T: function T() {
        return Timestamp;
      }
    }, {
      no: 7,
      name: "user_type",
      kind: "enum",
      T: function T() {
        return ["proto.edox.access.UserType", UserType];
      }
    }, {
      no: 8,
      name: "legal_form",
      kind: "enum",
      T: function T() {
        return ["proto.common.BusinessFormType", BusinessFormType, "BUSINESS_FORM_TYPE_"];
      }
    }]);
  }

  _createClass(UserAccount$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        authenticationId: "0",
        login: "",
        accountVerificationStatus: 0,
        fullName: "",
        shortName: "",
        userType: 0,
        legalForm: 0
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag3 = reader.tag(),
            _reader$tag4 = _slicedToArray(_reader$tag3, 2),
            fieldNo = _reader$tag4[0],
            wireType = _reader$tag4[1];

        switch (fieldNo) {
          case
          /* uint64 authentication_id */
          1:
            message.authenticationId = reader.uint64().toString();
            break;

          case
          /* string login = 2 [deprecated = true];*/
          2:
            message.login = reader.string();
            break;

          case
          /* proto.edox.access.AccountVerificationStatus account_verification_status */
          3:
            message.accountVerificationStatus = reader.int32();
            break;

          case
          /* string full_name */
          4:
            message.fullName = reader.string();
            break;

          case
          /* string short_name */
          5:
            message.shortName = reader.string();
            break;

          case
          /* google.protobuf.Timestamp created_at */
          6:
            message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
            break;

          case
          /* proto.edox.access.UserType user_type */
          7:
            message.userType = reader.int32();
            break;

          case
          /* proto.common.BusinessFormType legal_form */
          8:
            message.legalForm = reader.int32();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* uint64 authentication_id = 1; */
      if (message.authenticationId !== "0") writer.tag(1, WireType.Varint).uint64(message.authenticationId);
      /* string login = 2 [deprecated = true]; */

      if (message.login !== "") writer.tag(2, WireType.LengthDelimited).string(message.login);
      /* proto.edox.access.AccountVerificationStatus account_verification_status = 3; */

      if (message.accountVerificationStatus !== 0) writer.tag(3, WireType.Varint).int32(message.accountVerificationStatus);
      /* string full_name = 4; */

      if (message.fullName !== "") writer.tag(4, WireType.LengthDelimited).string(message.fullName);
      /* string short_name = 5; */

      if (message.shortName !== "") writer.tag(5, WireType.LengthDelimited).string(message.shortName);
      /* google.protobuf.Timestamp created_at = 6; */

      if (message.createdAt) Timestamp.internalBinaryWrite(message.createdAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
      /* proto.edox.access.UserType user_type = 7; */

      if (message.userType !== 0) writer.tag(7, WireType.Varint).int32(message.userType);
      /* proto.common.BusinessFormType legal_form = 8; */

      if (message.legalForm !== 0) writer.tag(8, WireType.Varint).int32(message.legalForm);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return UserAccount$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message proto.edox.access.UserAccount
 */


export var UserAccount = new UserAccount$Type(); // @generated message type with reflection information, may provide speed optimized methods

var UserAccountInfo$Type = /*#__PURE__*/function (_MessageType3) {
  _inherits(UserAccountInfo$Type, _MessageType3);

  var _super3 = _createSuper(UserAccountInfo$Type);

  function UserAccountInfo$Type() {
    _classCallCheck(this, UserAccountInfo$Type);

    return _super3.call(this, "proto.edox.access.UserAccountInfo", [{
      no: 1,
      name: "masked_phone",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 2,
      name: "masked_email",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 3,
      name: "user_accounts",
      kind: "message",
      repeat: 1
      /*RepeatType.PACKED*/
      ,
      T: function T() {
        return UserAccount;
      }
    }]);
  }

  _createClass(UserAccountInfo$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        maskedPhone: "",
        maskedEmail: "",
        userAccounts: []
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag5 = reader.tag(),
            _reader$tag6 = _slicedToArray(_reader$tag5, 2),
            fieldNo = _reader$tag6[0],
            wireType = _reader$tag6[1];

        switch (fieldNo) {
          case
          /* string masked_phone */
          1:
            message.maskedPhone = reader.string();
            break;

          case
          /* string masked_email */
          2:
            message.maskedEmail = reader.string();
            break;

          case
          /* repeated proto.edox.access.UserAccount user_accounts */
          3:
            message.userAccounts.push(UserAccount.internalBinaryRead(reader, reader.uint32(), options));
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* string masked_phone = 1; */
      if (message.maskedPhone !== "") writer.tag(1, WireType.LengthDelimited).string(message.maskedPhone);
      /* string masked_email = 2; */

      if (message.maskedEmail !== "") writer.tag(2, WireType.LengthDelimited).string(message.maskedEmail);
      /* repeated proto.edox.access.UserAccount user_accounts = 3; */

      for (var i = 0; i < message.userAccounts.length; i++) {
        UserAccount.internalBinaryWrite(message.userAccounts[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
      }

      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return UserAccountInfo$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message proto.edox.access.UserAccountInfo
 */


export var UserAccountInfo = new UserAccountInfo$Type(); // @generated message type with reflection information, may provide speed optimized methods

var PersonalData$Type = /*#__PURE__*/function (_MessageType4) {
  _inherits(PersonalData$Type, _MessageType4);

  var _super4 = _createSuper(PersonalData$Type);

  function PersonalData$Type() {
    _classCallCheck(this, PersonalData$Type);

    return _super4.call(this, "proto.edox.access.PersonalData", [{
      no: 1,
      name: "first_name",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 2,
      name: "last_name",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 3,
      name: "middle_name",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 4,
      name: "date_of_birth",
      kind: "message",
      T: function T() {
        return Date;
      }
    }, {
      no: 5,
      name: "gender",
      kind: "enum",
      T: function T() {
        return ["proto.edox.access.PersonalData.Gender", PersonalData_Gender];
      }
    }]);
  }

  _createClass(PersonalData$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        firstName: "",
        lastName: "",
        middleName: "",
        gender: 0
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag7 = reader.tag(),
            _reader$tag8 = _slicedToArray(_reader$tag7, 2),
            fieldNo = _reader$tag8[0],
            wireType = _reader$tag8[1];

        switch (fieldNo) {
          case
          /* string first_name */
          1:
            message.firstName = reader.string();
            break;

          case
          /* string last_name */
          2:
            message.lastName = reader.string();
            break;

          case
          /* string middle_name */
          3:
            message.middleName = reader.string();
            break;

          case
          /* google.type.Date date_of_birth */
          4:
            message.dateOfBirth = Date.internalBinaryRead(reader, reader.uint32(), options, message.dateOfBirth);
            break;

          case
          /* proto.edox.access.PersonalData.Gender gender */
          5:
            message.gender = reader.int32();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* string first_name = 1; */
      if (message.firstName !== "") writer.tag(1, WireType.LengthDelimited).string(message.firstName);
      /* string last_name = 2; */

      if (message.lastName !== "") writer.tag(2, WireType.LengthDelimited).string(message.lastName);
      /* string middle_name = 3; */

      if (message.middleName !== "") writer.tag(3, WireType.LengthDelimited).string(message.middleName);
      /* google.type.Date date_of_birth = 4; */

      if (message.dateOfBirth) Date.internalBinaryWrite(message.dateOfBirth, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
      /* proto.edox.access.PersonalData.Gender gender = 5; */

      if (message.gender !== 0) writer.tag(5, WireType.Varint).int32(message.gender);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return PersonalData$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message proto.edox.access.PersonalData
 */


export var PersonalData = new PersonalData$Type();